var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentcolor;;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.02523 13C7.02357 11.8141 7.25667 10.6395 7.71108 9.54398C8.16549 8.4485 8.83223 7.45379 9.67287 6.61719C10.5135 5.78059 11.5114 5.11864 12.6091 4.66951C13.7067 4.22037 14.8824 3.99293 16.0684 4.0003C21.0171 4.03709 24.9755 8.15046 24.9755 13.113V14C24.9755 18.477 25.9121 21.0749 26.7371 22.4948C26.826 22.6465 26.8732 22.819 26.8742 22.9948C26.8751 23.1707 26.8297 23.3436 26.7424 23.4963C26.6552 23.6489 26.5292 23.7759 26.3773 23.8643C26.2253 23.9528 26.0527 23.9996 25.8769 24H6.1228C5.94695 23.9996 5.77433 23.9528 5.62235 23.8643C5.47038 23.7758 5.34442 23.6489 5.25719 23.4962C5.16995 23.3435 5.12453 23.1705 5.1255 22.9946C5.12647 22.8188 5.1738 22.6463 5.26272 22.4946C6.08813 21.0746 7.02522 18.4768 7.02522 14L7.02523 13Z",
    className: "cls-1",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 24V25C12 26.0609 12.4214 27.0783 13.1716 27.8284C13.9217 28.5786 14.9391 29 16 29C17.0609 29 18.0783 28.5786 18.8284 27.8284C19.5786 27.0783 20 26.0609 20 25V24",
    className: "cls-1",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ae8262e57ebb850e624ac74d5a93df86.svg";
export { ForwardRef as ReactComponent };